import React from 'react';
import cx from 'classnames';
import { CloseCircleOutlined } from '@ant-design/icons';

import classes from './Icons.module.scss';

const CloseIcon = props => {
  const { className, onClick } = props;
  return (
    <CloseCircleOutlined
      className={cx(classes.CloseIcon, className)}
      onClick={onClick}
    />
  );
};

export default CloseIcon;
